"use client";

import ThinkingSvg from "../../assets/animations/thinking.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

export function ThinkingAnimation(props: SvgAnimationProps) {
  return <SvgAnimation {...props} svg={ThinkingSvg} />;
}
